<script setup lang="ts">
import { ESection, EButton } from '@/components/base/Email'
import EmailBlockWrapper from './EmailBlockWrapper.vue'
import EmailButtonToolbar from './EmailButtonToolbar.vue'
import type { ButtonBlock } from '../../types'

const { t } = useI18n()

const props = defineProps<{
  block: ButtonBlock
  isSelected: boolean
  colorPresets?: { color: string; label: string }[]
}>()

const emit = defineEmits<{
  (e: 'select'): void
  (e: 'update:block', block: ButtonBlock): void
}>()

const onTextBlur = (event: FocusEvent) => {
  const text = (event.target as HTMLElement).textContent || ''
  if (text !== props.block.text) {
    emit('update:block', { ...props.block, text })
  }
}
</script>

<template>
  <EmailBlockWrapper
    :is-selected="isSelected"
    :label="t('pages.email.emailTemplateCreatePage.blockButton')"
    cursor="pointer"
    :block-background-color="block.blockBackgroundColor"
    @select="emit('select')"
  >
    <ESection
      :key="`section-${block.id}-${block.textColor}-${block.align}`"
      :style="{
        textAlign: block.align,
        padding: '20px 0',
        pointerEvents: isSelected ? 'auto' : 'none'
      }"
    >
      <EButton
        :key="`btn-${block.id}-${block.backgroundColor}-${block.textColor}`"
        href="#"
        :style="{
          backgroundColor: `#${block.backgroundColor}`,
          color: `#${block.textColor}`,
          borderRadius: '8px',
          fontWeight: '500',
          fontSize: '16px',
          padding: '14px 28px'
        }"
        @click.prevent
      >
        <span
          :contenteditable="isSelected"
          :style="{ outline: 'none', cursor: isSelected ? 'text' : 'pointer' }"
          @blur="onTextBlur"
          @keydown.enter.prevent="($event.target as HTMLElement).blur()"
          >{{ block.text }}</span
        >
      </EButton>
    </ESection>
  </EmailBlockWrapper>

  <EmailButtonToolbar
    v-if="isSelected"
    :block="block"
    :color-presets="colorPresets"
    @update:block="emit('update:block', $event)"
  />
</template>
